import { render, staticRenderFns } from "./Mealie.vue?vue&type=template&id=608e2d76&"
import script from "./Mealie.vue?vue&type=script&lang=js&"
export * from "./Mealie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports